/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Survey2DInfo, Survey2DProfileResponse, Survey2DToUpdateInfo } from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class Survey2DClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags Survey2d
   * @summary Получить все 2d съёмки
   * @request GET:/Seismic/Survey2d
   * @secure
   */
  survey2DGetAllSurveys2D = (params: RequestParams = {}) =>
    this.http.request<Survey2DInfo[], any>({
      path: `/Seismic/Survey2d`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Survey2d
   * @summary Добавить новую съёмку 2D
   * @request POST:/Seismic/Survey2d
   * @secure
   */
  survey2DAddSurvey2D = (data: Survey2DInfo, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/Seismic/Survey2d`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Survey2d
   * @summary Изменить существующую съёмку 2D
   * @request PUT:/Seismic/Survey2d
   * @secure
   */
  survey2DUpdateSurvey2D = (data: Survey2DToUpdateInfo, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/Seismic/Survey2d`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    }) /**
   * No description
   *
   * @tags Survey2d
   * @summary Удалить существующую съёмку 2D
   * @request DELETE:/Seismic/Survey2d
   * @secure
   */
  survey2DDeleteSurvey2D = (
    query: {
      /**
       * Идентификатор съёмки 2D
       * @format uuid
       */
      survey2dId: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, any>({
      path: `/Seismic/Survey2d`,
      method: 'DELETE',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Survey2d
   * @summary Получить съёмку 2D по Id
   * @request GET:/Seismic/Survey2d/{survey2dId}
   * @secure
   */
  survey2DGetSurvey2DById = (survey2DId: string, params: RequestParams = {}) =>
    this.http.request<Survey2DInfo, any>({
      path: `/Seismic/Survey2d/${survey2DId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
 * No description
 * 
 * @tags Survey2d
 * @summary Получить съёмку 2D c отфильтрованным одним профилем по идентификатору профиля.
Остальные профили съёмки в профиль не войдут.
 * @request GET:/Seismic/Survey2d/OneProfileById/{profileId}
 * @secure
 */
  survey2DGetSurvey2DProfileByProfileId = (profileId: string, params: RequestParams = {}) =>
    this.http.request<Survey2DInfo, any>({
      path: `/Seismic/Survey2d/OneProfileById/${profileId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Survey2d
   * @summary Получить съёмку 2D с коллекцией профилей по Id съёмки
   * @request GET:/Seismic/Survey2d/survey2dWithProfiles/{surveyId}
   * @secure
   */
  survey2DGetSurvey2DProfileById = (surveyId: string, params: RequestParams = {}) =>
    this.http.request<Survey2DProfileResponse, any>({
      path: `/Seismic/Survey2d/survey2dWithProfiles/${surveyId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Survey2d
   * @summary Получить съёмки 2D по Id месторождения
   * @request GET:/Seismic/Survey2d/field/{fieldId}
   * @secure
   */
  survey2DGetSurveys2DByFieldId = (fieldId: string, params: RequestParams = {}) =>
    this.http.request<Survey2DInfo[], any>({
      path: `/Seismic/Survey2d/field/${fieldId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Survey2d
   * @summary Получить съёмки 2D по разлому
   * @request GET:/Seismic/Survey2d/fault/{faultId}
   * @secure
   */
  survey2DGetSurveys2DByFaultId = (faultId: string, params: RequestParams = {}) =>
    this.http.request<Survey2DInfo[], any>({
      path: `/Seismic/Survey2d/fault/${faultId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
}
